import React, { useMemo } from "react"
import Table from "../ui/Table"
import { Skeleton, Typography } from '@mui/material'


export default function DataTable({ datasetInfo, dataTable, dataset }) {
  const info = useMemo(() => datasetInfo && datasetInfo[0],[datasetInfo])
  const columns = [
    {label:'Date', id:'date'},
    {label:`${dataset.datasetName} - ${dataset.columnName}`, id: dataset.columnValue}
  ]

  return (
    <>
      <Typography variant="h2">{info ? info.name : <Skeleton/>}</Typography>
      <p>{info ? `Data description: ${info.description}` : <Skeleton/>}</p>
      <p>{info ? `Column description: ${info.columns.find(col => col.value === dataset.columnValue).description}` : <Skeleton/>}</p>
      <Table columns={columns} rows={dataTable} rowsPerPage={10}/>
    </>
    )
}
